<template>
  <section class="terms">
    <table class="table-new">
      <caption>
        민감정보 제3자 제공 동의
      </caption>
      <colgroup>
        <col span="4" />
      </colgroup>
      <thead>
      <tr>
        <th>제공받는 자</th>
        <th>제공받는 자의<br />이용 목적</th>
        <th>제공하는<br />민감정보 항목</th>
        <th>제공받는 자의 민감정보<br />보유 기간</th>
      </tr>
      </thead>
      <tbody>
      <tr>
        <td>
          <u class="primary--text">
            후유 가이드(전문 상담사)
          </u>
        </td>
        <td>
          <u class="primary--text">
            상담 서비스 제공 및 이력관리
          </u>
        </td>
        <td>
          <u class="primary--text">
            찐한 대화 채팅 내용, 여행지원서 문항별 응답값, 미션 문항별 응답값
          </u>
        </td>
        <td>
          <u class="primary--text">
            서비스 이용기간 또는
            제공받는 자의 이용 목적 달성 시 까지
          </u>
        </td>
      </tr>
      <tr>
      </tr>
      </tbody>
    </table>
    <p class="desc">
      이용자는 민감정보 3자 제공 동의를 거부할 권리가 있으며, 동의 거부 시 찐한대화 서비스 제공이 제한 될 수 있습니다.
    </p>
  </section>
</template>

<script>
export default {
  name: 'SensitiveThirdTerms'
}
</script>
